import { useFormContext, Controller, useController } from "react-hook-form";
import {
  MenuItem,
  FormControl,
  FormHelperText,
  TextField,
  OutlinedTextFieldProps,
} from "@mui/material";

interface IHLSelect extends Partial<OutlinedTextFieldProps> {
  name: string;
  options: { label: string; value: any }[];
}

export const HLSelect = ({ name, options, ...rest }: IHLSelect) => {
  const { control } = useFormContext();
  const { fieldState } = useController({ name, control });

  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          const { onChange, value, ...fieldProps } = field;

          return (
            <TextField
              variant="outlined"
              select
              fullWidth
              error={fieldState.error !== undefined}
              value={value ?? ""}
              onChange={(e) => onChange(e.target.value)}
              {...fieldProps}
              {...rest}
              InputLabelProps={{ shrink: true }}
            >
              {options.map(({ label, value }) => (
                <MenuItem value={value} key={label}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
          );
        }}
      />
      {fieldState.error && (
        <FormHelperText error>{fieldState.error.message}</FormHelperText>
      )}
    </FormControl>
  );
};

export default HLSelect;
